import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class EntityReportService extends BaseApiTemplateService<any> {    

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity-reports';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-reports';
    this.httpClient = http;
  }

  public getEntityReportByCriteria(
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = url + "/entity/backoffice-ep?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getDocumentReportByCriteria(
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = url + "/document/backoffice-ep?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getAgingDetails(inputModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let url = this.apiUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path;
    }
    const newURL = url + "/aging/backoffice-ep";
    let formData = {};
    if (inputModel) formData = inputModel;

    return this.httpClient.post<ApiResponseModel<any>>(
      newURL,
      formData,
      this.getHttpHeader(apiVisa)
    );
  }
  
}